module.exports = __webpack_public_path__ + "static/img/4.88ff88f.png";


//////////////////
// WEBPACK FOOTER
// ./src/daoba-match/assets/internetimg/4.png
// module id = OmIB
// module chunks = 9